import Footer from "../components/Footer";
import NavbarComponent from "../components/Navbar";


const TermsAndCondition = () => {
    return (
        <>
            <NavbarComponent />

            <div className="container my-5">
                {/* Page Title */}
                <h1 className="text-center mb-5 fw-semibold title-font">
                    Privacy Policy & Terms
                </h1>

                {/* Privacy Policy Section */}
                <div className="card mb-4 shadow-sm border-0 rounded-4 p-3 bg-light">
                    <div className="card-body">
                        <h2 className="fw-semibold title-font mb-3" style={{color: '#043927'}}>
                            Privacy Policy
                        </h2>
                        <p>
                            We respect your privacy and are committed to protecting your
                            personal information.
                        </p>

                        <div className="card border-0 bg-white p-2">
                            <p>
                                We collect basic details such as name, contact number, email
                                address, and payment information for order processing and customer
                                support.
                            </p>
                            <p>
                                Your information will never be sold, rented, or shared with third
                                parties except when required by law or for essential business
                                services (like payment gateways).
                            </p>
                            <p>
                                We use secure methods to protect your data against unauthorized
                                access.
                            </p>
                            <p>
                                By using our services, you consent to the collection and use of
                                your information as outlined here.
                            </p>
                        </div>
                    </div>
                </div>

                {/* Terms & Conditions Section */}
                <div className="card mb-4 shadow-sm border-0 rounded-4 p-3 bg-light">
                    <div className="card-body">
                        <h2 className="fw-semibold title-font mb-3" style={{color: '#043927'}}>
                            Terms & Conditions
                        </h2>

                        <div className="card border-0 bg-white p-2">
                            <p>
                                By using our services/products, you agree to comply with these
                                Terms & Conditions.
                            </p>
                            <p>
                                Prices, menu items, and services are subject to change without
                                prior notice.
                            </p>
                            <p>
                                Customers must provide accurate details during
                                orders/registrations.
                            </p>
                            <p>
                                Any misuse of our brand name, services, or fraudulent activity may
                                result in cancellation of service and legal action.
                            </p>
                            <p>We are not liable for delays or failures caused by events beyond our control (natural disasters, strikes, internet issues, etc.).</p>
                            <p>Continued use of our service means acceptance of these terms.</p>
                        </div>
                    </div>
                </div>


                {/* Refund & Cancellation Policy Section */}
                <div className="card mb-4 shadow-sm border-0 rounded-4 p-3 bg-light">
                    <div className="card-body">
                        <h2 className="fw-semibold title-font mb-3" style={{color: '#043927'}}>
                            Refund & Cancellation Policy
                        </h2>

                        <div className="card border-0 bg-white p-2">
                            <p>
                                Orders once placed cannot be canceled after processing.
                            </p>
                            <p>
                                In case of wrong delivery, damaged products, or failed service, you may request a refund/replacement within 24 hours of purchase.
                            </p>
                            <p>
                                Refunds (if applicable) will be processed to the original payment method within 7–10 working days.
                            </p>
                            <p>
                                For event/program bookings, cancellations made 7 days before the event are eligible for a full refund. After that, only partial or no refunds may apply.
                            </p>
                            <p>Management reserves the right to approve or deny refund requests based on the situation.</p>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};


export default TermsAndCondition